  (function () {
    if (window.__wbSearchRedirectBound) return;
    window.__wbSearchRedirectBound = true;

    var SEARCH_URL = (document.querySelector('#header-component') || {}).getAttribute
      ? document.querySelector('#header-component').getAttribute('data-search-url') || '/search'
      : '/search';

    // ---- brand -> vendor map ----
    var brandVendorMap = {};
    try {
      var arr = window.__wbBrandProfiles || [];
      arr.forEach(function (it) {
        if (!it || !it.brand) return;
        brandVendorMap[String(it.brand).toLowerCase().trim()] = String(it.vendor || '').trim();
      });
    } catch (e) {}

    function getVendorForBrand(brand) {
      var b = String(brand || '')
        .toLowerCase()
        .trim();
      if (!b) return '';
      return (brandVendorMap[b] || '').trim();
    }

    function getBrandFromHeader() {
      var header = document.querySelector('#header-component');
      if (!header) return '';
      var brand = (header.getAttribute('data-wb-brand') || '').toLowerCase().trim();
      if (!brand || brand === 'default') return '';
      return brand;
    }

    function getVendorFromHeader() {
      var header = document.querySelector('#header-component');
      if (!header) return '';
      return (header.getAttribute('data-wb-search-vendor') || '').trim();
    }

    function getBrandFromUrl() {
      try {
        return (new URL(location.href).searchParams.get('brand') || '').toLowerCase().trim();
      } catch (e) {
        return '';
      }
    }

    function splitVendors(v) {
      return String(v || '')
        .replace(/\|/g, ',')
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
    }

    function buildVendorQuery(vendorRaw) {
      var vendors = splitVendors(vendorRaw);
      if (!vendors.length) return '';
      if (vendors.length === 1) return 'vendor:"' + vendors[0].replace(/"/g, '\\"') + '"';
      return (
        '(' +
        vendors
          .map(function (v) {
            return 'vendor:"' + v.replace(/"/g, '\\"') + '"';
          })
          .join(' OR ') +
        ')'
      );
    }

    function buildSearchUrl(q, brand, vendorRaw) {
      var query = (q || '').trim();

      // ✅ vendor句は「brandから引けるなら常に付ける」
      if (vendorRaw && !/vendor\s*:/i.test(query)) {
        var vq = buildVendorQuery(vendorRaw);
        if (vq) query = vq + ' ' + query;
      }

      query = query.replace(/\s+/g, ' ').trim();

      var url = new URL(SEARCH_URL, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('type', 'product');
      if (brand) url.searchParams.set('brand', brand);

      return url.toString();
    }

    function findSearchInputFromEvent(e) {
      var path = (e.composedPath && e.composedPath()) || [];
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || !el.tagName) continue;
        if (el.tagName.toLowerCase() === 'input') {
          var type = (el.getAttribute('type') || '').toLowerCase();
          var name = (el.getAttribute('name') || '').toLowerCase();
          if (name === 'q' || type === 'search') return el;
        }
      }
      return document.querySelector('input[name="q"], input[type="search"]');
    }

    // 表示上だけ vendor句を消す（入力欄用）
    function stripVendorForDisplay(val, vendorRaw) {
      if (!val) return val;
      var out = String(val);

      if (vendorRaw) {
        var vendors = splitVendors(vendorRaw);
        vendors.forEach(function (v) {
          var vn = String(v)
            .replace(/\u3000/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
          var vEsc = vn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '[\\s\\u3000]+');
          var re1 = new RegExp('\\s*vendor\\s*:\\s*"' + vEsc + '"\\s*', 'ig');
          var re2 = new RegExp('\\s*vendor\\s*:\\s*&quot;' + vEsc + '&quot;\\s*', 'ig');
          out = out.replace(re1, ' ').replace(re2, ' ');
        });
      } else {
        out = out.replace(/\s*vendor\s*:\s*(?:"[^"]*"|&quot;[^&]*&quot;)\s*/gi, ' ');
      }

      out = out.replace(/[()]/g, ' ');
      out = out.replace(/\bOR\b/gi, ' ');
      out = out.replace(/\s+/g, ' ').trim();
      return out;
    }

    function getEffectiveBrand() {
      // ✅ URL > header のみ（storageは使わない）
      return getBrandFromUrl() || getBrandFromHeader();
    }

    function getEffectiveVendorRaw(brand) {
      // ✅ brand辞書 > header属性（最後の保険）
      return getVendorForBrand(brand) || getVendorFromHeader();
    }

    function stripVendorForDisplayEverywhere() {
      var brand = getEffectiveBrand();
      var vendor = getEffectiveVendorRaw(brand);

      document.querySelectorAll('input[name="q"], input[type="search"]').forEach(function (input) {
        var before = input.value || '';
        var after = stripVendorForDisplay(before, vendor);
        if (before !== after) input.value = after;
      });
    }

    function redirectToSearch(e) {
      var brand = getEffectiveBrand();
      if (!brand) return;

      var input = findSearchInputFromEvent(e);
      if (!input) return;

      var q = (input.value || '').trim();
      if (!q) return;

      e.preventDefault();
      e.stopPropagation();

      var vendor = getEffectiveVendorRaw(brand);
      window.location.href = buildSearchUrl(q, brand, vendor);
    }

    function fixSearchBrandIfMissing() {
      try {
        var u = new URL(location.href);
        if (u.pathname !== SEARCH_URL) return;
        if (u.searchParams.get('brand')) return;

        var brand = getBrandFromUrl() || getBrandFromHeader();
        if (!brand) return;

        u.searchParams.set('brand', brand);
        location.replace(u.toString());
      } catch (e) {}
    }

    // ✅ /searchリンク & フォームに brand補完（対象を絞って軽量化）
    function ensureBrandParamEverywhere() {
      var brand = getEffectiveBrand();
      if (!brand) return;

      // /search っぽいリンクだけ（相対URLの高速パス）
      document.querySelectorAll('a[href^="/search"], a[href*="/search?"]').forEach(function (a) {
        try {
          var href = a.getAttribute('href');
          if (!href) return;

          var u = new URL(href, window.location.origin);
          if (u.pathname !== SEARCH_URL) return;

          if (!u.searchParams.get('brand')) {
            u.searchParams.set('brand', brand);
            a.setAttribute('href', u.pathname + '?' + u.searchParams.toString());
          }
        } catch (e) {}
      });

      // action が /search のフォームだけ（"form" 全体を舐めない）
      document.querySelectorAll('form[action^="/search"], form[action*="/search"]').forEach(function (form) {
        var qInput = form.querySelector('input[name="q"], input[type="search"]');
        if (!qInput) return;

        var input = form.querySelector('input[name="brand"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'brand';
          form.appendChild(input);
        }
        input.value = brand;
      });
    }

    // --- 初期化 ---
    // searchページに来ちゃった後でも brand を復元
    fixSearchBrandIfMissing();

    // strip は scheduleSync() 側でまとめて実行

    document.addEventListener('submit', redirectToSearch, true);

    document.addEventListener(
      'click',
      function (e) {
        // /searchリンククリックも補足して brand を付ける
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (a) {
          var href = a.getAttribute('href') || '';
          // /search以外は即return（URL作らない）
          if (href.indexOf('/search') === -1) {
            // noop
          } else {
            try {
              var u = new URL(href, window.location.origin);
              if (u.pathname === SEARCH_URL && !u.searchParams.get('brand')) {
                var brand = getEffectiveBrand();
                if (brand) {
                  u.searchParams.set('brand', brand);
                  a.setAttribute('href', u.pathname + '?' + u.searchParams.toString());
                }
              }
            } catch (err) {}
          }
        }

        // submitボタンのクリックは強制リダイレクト
        var path = (e.composedPath && e.composedPath()) || [];
        for (var i = 0; i < path.length; i++) {
          var el = path[i];
          if (!el || !el.tagName) continue;
          var tag = el.tagName.toLowerCase();
          if (tag === 'button' || tag === 'input') {
            var type = (el.getAttribute('type') || '').toLowerCase();
            if (type === 'submit') {
              redirectToSearch(e);
              return;
            }
          }
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter') return;
        var t = e.target;
        if (!t || !t.tagName) return;
        if (t.tagName.toLowerCase() === 'input') {
          var type = (t.getAttribute('type') || '').toLowerCase();
          var name = (t.getAttribute('name') || '').toLowerCase();
          if (name === 'q' || type === 'search') redirectToSearch(e);
        }
      },
      true
    );

    // --- Observer最適化（必要時だけ実行）---
    var scheduled = false;
    var lastBrand = '';

    function getBrandFast() {
      // URL優先（tryを避ける高速版）
      var m = location.search.match(/[?&]brand=([^&]+)/i);
      var b = m ? decodeURIComponent(m[1] || '') : '';
      b = (b || '').toLowerCase().trim();
      if (b && b !== 'default') return b;
      return getBrandFromHeader(); // fallback
    }

    function scheduleSync(reason) {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;

        var brand = getBrandFast();
        var brandChanged = brand && brand !== lastBrand;

        // brandが変わった時だけリンク/フォーム補完（重い処理を間引く）
        if (brandChanged) {
          lastBrand = brand;
          ensureBrandParamEverywhere();
        }

        // search入力の整形は「searchページ or inputが触られた時」に限定
        // （reasonが"input"の時だけ走らせる）
        if (reason === 'input' || location.pathname === SEARCH_URL) {
          stripVendorForDisplayEverywhere();
        }
      });
    }

    var root = document.querySelector('#header-group') || document.querySelector('#header-component') || document.body;

    new MutationObserver(function (mutations) {
      // input/search要素が追加された時だけ strip 予約
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;

          // 追加されたノード自身 or 配下に search input があるときだけ
          if (
            (n.matches && n.matches('input[name="q"], input[type="search"]')) ||
            (n.querySelector && n.querySelector('input[name="q"], input[type="search"]'))
          ) {
            scheduleSync('input');
            return;
          }
        }
      }

      // それ以外は brand変更が起きた可能性だけ確認
      scheduleSync('mut');
    }).observe(root, { childList: true, subtree: true });

    // 初回：brand確定とリンク補完だけ
    scheduleSync('init');
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync('init');
    });
  })();
